import { Component, OnInit, Output, EventEmitter, inject } from '@angular/core';
import { AttachmentsService } from '../../service/files-and-attachments/attachments.service';

import { AgGridModule } from 'ag-grid-angular';

import { MatSidenavModule } from '@angular/material/sidenav';
import { MatDividerModule } from '@angular/material/divider';

import * as attachmentsColumns from '../../shared/entity-columns/attachments-columns';


@Component({
    selector: 'app-attachment-list',
    templateUrl: './attachment-list.component.html',
    styleUrls: ['./attachment-list.component.css'],
    standalone: true,
    imports: [
      AgGridModule,
      MatSidenavModule,
      MatDividerModule
    ]
  })
export class AttachmentListComponent implements OnInit {
  private attachmentsService = inject(AttachmentsService);

  attachmentList: any[] = [];

  allColumns = attachmentsColumns.allColumns;

  defaultUserViewCols = [
        attachmentsColumns.colAttachmentName,
        attachmentsColumns.colType
    ];

  colAttachmentName =  {
      colId: 'attachmentName',
      headerName: 'Template Name',
      field: 'attachmentData.name',
      width: 100
  };

  columnsAttachmentList = [
    attachmentsColumns.colAttachmentCreatedDate,
    attachmentsColumns.colAttachmentName,
    attachmentsColumns.colType,
    attachmentsColumns.colAttachmentDescription,
  ]

  gridApi = null;

  defaultColDef = { resizable: true,
                    sortable: true,
                    filter: true};

  attachmentsFilter = null;
  listTitle = null;

  @Output() messageEvent = new EventEmitter<string>();

  constructor() { 

    }

  async ngOnInit() {
    this.attachmentsService.refreshAllAttachmentsRecords();

    this.attachmentsService.allAttachments$.subscribe(allAttachments => {
      // When the data arrives, assign it to your component's property
      this.attachmentList = allAttachments;
    });

    // BUGBUG ANGULAR 20 UPGRADE - I don't remember what this was for and I doubt we need it
    // this.attachmentList = this.attachmentsService.filterAttachmentListForLetters(this.attachmentList);

    if (this.attachmentsFilter) {
      this.attachmentList = this.attachmentList.filter( attachment => attachment.attachmentData.attachmentType === this.attachmentsFilter);
      this.columnsAttachmentList = [this.colAttachmentName];
    }

  }


  onCellClicked(event: any) {
      this.messageEvent.emit(event.data.attachmentData);
      // this.dialogRef.close(event.data);
  }



  onGridReady(params) {
    this.gridApi = params.api;
    //this.gridColumnApi = params.columnApi;
  }

}
